// Functionality to create add to page and handle functionality inside for popups

// Class to handle all functionalities od popup
class popup {
    constructor() { }

    // @param string structure
    // Structure that will be added insde popup
    init(structure, customClass = "", type = "div") {
        return new Promise((resolve, reject) => {
            // Create structure of popup

            // Wrapper by default will be div, but can be whatever
            this.popup = document.createElement(type);
            this.popup.classList.add("popup");
            this.popup.classList.add("state--visible");
            this.popup.classList.add(customClass);
            this.popup.setAttribute("data-item", "popup");

            // Create popup wrapper for custom scroll
            this.popupWrapper = document.createElement("div");
            //this.popupWrapper.setAttribute("data-custom-scroll", "init");
            this.popup.appendChild(this.popupWrapper);


            document.body.appendChild(this.popup);

            // Add to document
            this.popupWrapper.insertAdjacentHTML('beforeend', structure);

            // Create popup bg
            this.popupBg = document.createElement("span");
            this.popupBg.classList.add("popup-bg");
            this.popupBg.classList.add("state--visible");
            document.body.appendChild(this.popupBg);

            // Disable scroll
            //document.getElementsByTagName("html")[0].classList.add("prevent-scroll");


            // Init all basic functionalities 

            // Init functionality to close popup
            const closeButtons = this.popup.querySelectorAll(`[data-popup-action="close"]`);
            if (closeButtons.length > 0) {
                closeButtons.forEach(close => {
                    close.addEventListener('click', () => {
                        this.close();
                    })
                })
            }

            // Init functionality for custom scrollbar
           // document.body.dispatchEvent(new Event('bw-custom-scroll-reload'));

            resolve("popup init finished");
        })
    }

    // Function to close popup and remove it from structure
    close() {
        this.popup.remove();
        this.popupBg.remove();
        document.getElementsByTagName("html")[0].classList.remove("prevent-scroll");
        sessionStorage.setItem('mac-popup', 1);
    }
}

export default popup;